<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <el-form
      :model="detailInfo"
      ref="detailInfo"
      label-width="0px"
      class="demo-dynamic form-horizontal detailPage"
    >
      <el-tabs type="border-card">
        <el-tab-pane
          :label="$t('message.' + langItem.langCode)"
          v-for="(langItem, index) in detailInfo.lstSchoolEventLangDTO"
          :key="index"
        >
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label"> Event Title </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="`lstSchoolEventLangDTO[${index}].eventTitle`"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input
                      v-model="langItem.eventTitle"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">IDEAS Category</label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="ideasCategory"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-select
                      v-model="detailInfo.ideasCategory"
                      clearable
                      name="ideasCategory"
                    >
                      <el-option
                        v-for="item in [
                          { key: 'I', label: 'Innovation' },
                          { key: 'D', label: 'Discipline' },
                          { key: 'E', label: 'Exposure' },
                          { key: 'A', label: 'Adventure' },
                          { key: 'S', label: 'Synergy' },
                        ]"
                        :label="item.label"
                        :value="item.key"
                        :key="item.key"
                        class="ng-binding"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  All Year round Indicator
                </label>
                <div class="col-sm-10">
                  <el-form-item prop="allYearRoundIndicator">
                    <el-checkbox
                      v-model="allYearRoundIndicator"
                      @change="handleSelectEventAllYearRound"
                    ></el-checkbox>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Event Start Date & Time
                </label>
                <div class="col-sm-10">
                  <div style="display: flex">
                    <el-form-item
                      prop="startEventDate"
                      style="width: 300px !important"
                      :rules="{
                        required: true,
                        message: $t('message.required'),
                        trigger: ['blur', 'change'],
                      }"
                    >
                      <el-date-picker v-model="startSubDate" type="date">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item
                      prop="startEventDate"
                      style="margin-left: 20px; width: 300px !important"
                      :rules="{
                        required: true,
                        message: $t('message.required'),
                        trigger: ['blur', 'change'],
                      }"
                    >
                      <el-time-picker v-model="startSubTime"> </el-time-picker>
                    </el-form-item>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Event End Date & Time
                </label>
                <div class="col-sm-10">
                  <div style="display: flex">
                    <el-form-item
                      prop="endEventDate"
                      style="width: 300px !important"
                      :rules="{
                        required: true,
                        message: $t('message.required'),
                        trigger: ['blur', 'change'],
                      }"
                    >
                      <el-date-picker v-model="endSubDate" type="date">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item
                      prop="endEventDate"
                      style="margin-left: 20px; width: 300px !important"
                      :rules="{
                        required: true,
                        message: $t('message.required'),
                        trigger: ['blur', 'change'],
                      }"
                    >
                      <el-time-picker v-model="endSubTime"> </el-time-picker>
                    </el-form-item>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">Event District</label>
                <div class="col-sm-10">
                  <el-form-item prop="eventDistrictCode">
                    <el-select
                      :disabled="userRole != 0"
                      v-model="detailInfo.eventDistrictCode"
                      v-bind:placeholder="$t('message.PleaseSelect')"
                      name="eventDistrictCode"
                      @change="handleChangeDistrictCode"
                    >
                      <el-option
                        v-for="item in districtGetlist"
                        :key="item.districtCode"
                        :label="item.districtNameEn"
                        :value="item.districtCode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label"> Event location </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="`lstSchoolEventLangDTO[${index}].location`"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input
                      v-model="langItem.location"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label"> Description </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="`lstSchoolEventLangDTO[${index}].description`"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <ckeditor
                      :editor="editor"
                      @ready="editorOnReady"
                      v-model="langItem.description"
                      :config="editorConfig"
                    ></ckeditor>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Event Images (max. 5)
                </label>
                <div class="col-sm-10" style="display: flex">
                  <vuedraggable
                    v-model="detailInfo.lstSchoolEventImageDTO"
                    class="drag"
                  >
                    <transition-group>
                      <div
                        class="dragInfo"
                        v-for="item in detailInfo.lstSchoolEventImageDTO"
                        :key="item.eventImageUrl"
                      >
                        <el-image :src="item.showEventImageUrl"></el-image>
                        <i
                          class="el-icon-delete dragDelete"
                          @click="handleRemove(item)"
                        ></i>
                      </div>
                    </transition-group>
                  </vuedraggable>

                  <el-upload
                    action="#"
                    :http-request="uploadFile"
                    :file-list="detailInfo.lstSchoolEventImageDTO"
                    list-type="picture-card"
                    accept=".png, .jpg , .jpeg"
                    :auto-upload="true"
                    :show-file-list="false"
                  >
                    <div
                      slot="tip"
                      v-if="uploadErr"
                      style="color: red; font-size: 10px"
                      class="el-upload__tip"
                    >
                      The uploaded file should not exceed 5MB
                    </div>
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{ file }">
                      <img
                        class="el-upload-list__item-thumbnail"
                        :src="file.showEventImageUrl"
                        alt=""
                      />
                      <span class="el-upload-list__item-actions">
                        <span
                          class="el-upload-list__item-delete"
                          @click="handleRemove(file)"
                        >
                          <i class="el-icon-delete"></i>
                        </span>
                      </span>
                    </div>
                  </el-upload>
                </div>
                <label class="col-sm-2 control-label"></label>
                <el-form-item
                  class="col-sm-10"
                  :prop="'imageListIsNull'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'change',
                  }"
                >
                  <el-input
                    style="display: none"
                    v-model="detailInfo.imageListIsNull"
                    show-word-limit
                  ></el-input>
                </el-form-item>
              </div>

              <el-divider></el-divider>

              <div style="font-size: 16px; margin-bottom: 27px">
                Promote the event to
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Scope Type</label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="scopeType"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                   
                    <el-select
                      v-model="detailInfo.scopeType"
                      name="scopeType"
                      @change="handleChangeScopeType"
                    >
                      <el-option
                        v-for="item in scopeTypeMap"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group" v-if="detailInfo.scopeType == 1">
                <label class="col-sm-2 control-label">District</label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="lstDistritCode"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                  <!-- TODO -->
                    <el-select
                      v-model="detailInfo.lstDistritCode"
                      name="district"
                      multiple
                    >
                      <el-option
                        v-for="item in districtGetlist"
                        :key="item.districtCode"
                        :label="item.districtNameEn"
                        :value="item.districtCode"
                      >
                      </el-option>
                    </el-select>
                    <el-button style="margin-top:20px;" @click="handleSelectAllDistrit">{{distritIsSelectAll?'Unselect All Districts':'Select All District'}}</el-button>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group" v-if="detailInfo.scopeType == 2">
                <label class="col-sm-2 control-label">School Level</label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="level"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-checkbox-group
                      v-model="schoolLevel"
                      @change="handleClickLevel"
                    >
                      <el-checkbox label="Primary school"></el-checkbox>
                      <el-checkbox label="Secondery school"></el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group" v-if="detailInfo.scopeType == 3">
                <label class="col-sm-2 control-label">School</label>
                <div class="col-sm-7">
                  <el-form-item
                    prop="lstSchoolCode"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <!-- <el-select
                      disabled
                      class="schoolSelecter"
                      v-model="detailInfo.lstSchoolCode"
                      filterable
                      multiple
                      placeholder="Add schools"
                    >
                      <el-option
                        v-for="item in schoolCodeList"
                        :key="item.id"
                        :label="item.schoolName"
                        :value="item.schoolCode"
                      >
                      </el-option>
                    </el-select> -->
                    <el-button @click="handleShowModel">School Filter</el-button>
                    <el-table
                      v-show="
                        detailInfo.lstSchoolCode &&
                        detailInfo.lstSchoolCode.length
                      "
                      :data="detailInfo.lstSchoolCode"
                      style="width: 100%"
                      :show-header="false"
                      :cell-style="{ borderBottom: '0' }"
                    >
                      <el-table-column>
                        <template slot-scope="scope">
                          {{
                            schoolCodeList.find((i) => {
                              return i.schoolCode == scope.row.schoolCode;
                            })?schoolCodeList.find((i) => {
                              return i.schoolCode == scope.row.schoolCode;
                            }).schoolName:''
                          }}
                        </template>
                      </el-table-column>
                      <el-table-column width="60">
                        <template slot-scope="scope">
                          <el-button
                            type="text"
                            size="mini"
                            style="padding: 0"
                            @click="handleDelectSchool(scope.row)"
                          >
                            <i class="el-icon-close"></i>
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-form-item>
                </div>
              </div>

              <el-divider></el-divider>

              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Publish Date & Time (Start)
                </label>
                <div class="col-sm-10">
                  <el-form-item prop="'startPublishDate">
                    <div style="display: flex">
                      <el-date-picker
                        style="width: 300px !important"
                        v-model="startPublishDate"
                        type="date"
                      >
                      </el-date-picker>
                      <el-time-picker
                        style="margin-left: 20px; width: 300px !important"
                        v-model="startPublishTime"
                      >
                      </el-time-picker>
                    </div>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Publish Date & Time (End)</label
                >
                <div class="col-sm-10">
                  <el-form-item prop="'endPublishDate">
                    <div style="display: flex">
                      <el-date-picker
                        style="width: 300px !important"
                        v-model="endPublishDate"
                        type="date"
                      >
                      </el-date-picker>
                      <el-time-picker
                        style="margin-left: 20px; width: 300px !important"
                        v-model="endPublishTime"
                      >
                      </el-time-picker>
                    </div>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label"> Status </label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="status"
                    :rules="[
                      {
                        required: true,
                        message: $t('message.required'),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-select
                      style="width: 200px !important"
                      v-model="detailInfo.status"
                      :name="'status'"
                      disabled
                    >
                      <el-option
                        v-for="item in statusMap"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Event Full Indicator
                </label>
                <div class="col-sm-10">
                  <el-form-item prop="isEventFull">
                    <el-checkbox v-model="detailInfo.isEventFull"></el-checkbox>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-12">
                  <div>
                    <el-button
                      @click="handleCopyTo"
                      v-if="$route.query.id"
                      style="float: left"
                      >Copy to</el-button
                    >
                  </div>
                  <div class="pull-right">
                    <el-button
                      :disabled="detailInfo.status == 6"
                      type="primary"
                      @click="checkEvent()"
                      v-if="
                        (checkPermission('SchoolEvent_LIST_EDIT') && $route.query.id) ||
                        (checkPermission('SchoolEvent_LIST_ADD') && !$route.query.id)
                      "
                      >{{ $route.query.id ? "Save" : "Add" }}</el-button
                    >
                    <el-button @click="showWarning()">{{
                      $t("message.Cancel")
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <schoolSelectModel :isMultiple="true" @add="handleSelectSchool" @close="handleCloseModel" :districtCode="detailInfo.eventDistrictCode" :isShowAddModel="isShowModel"/>
  </div>
</template>
<script>
import config from "../config";
import vuedraggable from "vuedraggable";
import ClassicEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import schoolSelectModel from '../components/schoolSelectModel/index.vue'

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      detailInfo: {
        eventTitle: "",
        ideasCategory: "I",
        startDate: "",
        endDate: "",
        eventDistrictCode: "",
        lstDistritCode: [],
        level: 0,
        lstSchoolCode: [],
        status: 0,
        isEventFull: false,
        lstSchoolEventImageDTO: [],
        lstSchoolEventLangDTO: [],
        startEventDate: "",
        endEventDate: "",
        imageListIsNull: "No",
        isAllYearEvent: false,
      },
      schoolCodeList: [],
      districtGetlist: [],
      allYearRoundIndicator: "",
      startSubDate: "",
      startSubTime: "",
      endSubDate: "",
      endSubTime: "",
      startPublishDate: "",
      startPublishTime: "",
      endPublishDate: "",
      endPublishTime: "",
      editor: ClassicEditor,
      schoolLevel: [],
      uploadErr: false,
      isShowModel:false
    };
  },
  computed: {
    _language() {
      return this.$store.state.userInfo.langCode;
    },
    editorConfig() {
      return {
        toolbar: [
          "Heading",
          "bold",
          "italic",
          "underline",
          "Link",
          "bulletedList",
          "numberedList",
          "fontfamily",
          "fontsize",
          "alignment",
          "outdent",
          "indent",
          "undo",
          "redo",
        ],
      };
    },
    statusMap() {
      return [
        { label: "DRAFT", value: 0 },
        { label: "SUSPENDED", value: 4 },
        { label: "PUBLISHED", value: 6 },
      ];
    },
    scopeTypeMap() {
      return [
        { label: "District", value: 1 },
        { label: "School Level", value: 2 },
        { label: "School", value: 3 },
      ];
    },
    userRole() {
      const res = JSON.parse(sessionStorage.getItem("userInfo"));
      return res.roleType;
    },
    userDistrictCode(){
      const res =JSON.parse(sessionStorage.getItem("userInfo"));
      return res.userDistrictCode
    },
    distritIsSelectAll(){
      const sameList = this.$lodash.intersectionWith(this.detailInfo.lstDistritCode,this.districtGetlist,(x,y)=>{
        return x == y.districtCode
      })
      return sameList.length == this.districtGetlist.length
    }
  },
  watch: {
    detailInfo: {
      handler: function () {
        this.$store.state.edit = true;
      },
      deep: true,
    },
    startSubDate: {
      handler: function (e) {
        this.handleChangeDate(e, "start");
      },
      deep: true,
    },
    startSubTime: {
      handler: function (e) {
        this.handleChangeDate(e, "start");
      },
      deep: true,
    },
    endSubDate: {
      handler: function (e) {
        this.handleChangeDate(e, "end");
      },
      deep: true,
    },
    endSubTime: {
      handler: function (e) {
        this.handleChangeDate(e, "end");
      },
      deep: true,
    },
    startPublishDate: {
      handler: function (e) {
        this.handleChangePublishDate(e, "start");
      },
      deep: true,
    },
    startPublishTime: {
      handler: function (e) {
        this.handleChangePublishDate(e, "start");
      },
      deep: true,
    },
    endPublishDate: {
      handler: function (e) {
        this.handleChangePublishDate(e, "end");
      },
      deep: true,
    },
    endPublishTime: {
      handler: function (e) {
        this.handleChangePublishDate(e, "end");
      },
      deep: true,
    },
  },
  async created() {
    var obj = [];
    for (var i = 0; i < this.$store.state.userInfo.language.length; i++) {
      obj.push({
        langCode: this.$store.state.userInfo.language[i].langCode,
        title: "",
        description: "",
      });
    }
    this.$set(this.detailInfo, "lstSchoolEventLangDTO", obj);
    await this.getSchoolCodeList();
    await this.getDistrictGetlist();
    await this.init();
  },
  mounted() {
    if(this.userRole != 0 ){
      this.detailInfo.eventDistrictCode = this.userDistrictCode
    }
    this.getSchoolCodeList();
  },
  methods: {
    async init() {
      let id = this.$route.query.id;
      var that = this;
      if (id) {
        let obj = this.getAuthObj();
        obj.id = id;
        obj.apiUrl = this.apiConfig.schoolEventDetail;
        let data = await this.$store.dispatch("apiEvent", obj);
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        data.data.result.isAllYearEvent &&
          (data.data.result.isAllYearEvent =
            data.data.result.isAllYearEvent.toString());
        this.detailInfo = data.data.result;
        this.detailInfo.isEventFull = !!this.detailInfo.isEventFull;
        this.detailInfo.lstSchoolEventImageDTO.length
          ? (this.detailInfo.imageListIsNull = "No")
          : "";

        if (Number(this.detailInfo.isAllYearEvent)) {
          this.handleSelectEventAllYearRound(true);
        } else {
          this.startSubDate = this.detailInfo.startEventDate
            ? this.$dayjs(this.detailInfo.startEventDate).toDate()
            : "";
          this.startSubTime = this.detailInfo.startEventDate
            ? this.$dayjs(this.detailInfo.startEventDate).toDate()
            : "";
          this.endSubDate = this.detailInfo.endEventDate
            ? this.$dayjs(this.detailInfo.endEventDate).toDate()
            : "";
          this.endSubTime = this.detailInfo.endEventDate
            ? this.$dayjs(this.detailInfo.endEventDate).toDate()
            : "";
        }
        this.detailInfo.startPublishDate
          ? (this.startPublishDate = this.$dayjs(
              this.detailInfo.startPublishDate
            ).toDate())
          : "";
        this.detailInfo.startPublishDate
          ? (this.startPublishTime = this.$dayjs(
              this.detailInfo.startPublishDate
            ).toDate())
          : "";
        this.detailInfo.endPublishDate
          ? (this.endPublishDate = this.$dayjs(
              this.detailInfo.endPublishDate
            ).toDate())
          : "";
        this.detailInfo.endPublishDate
          ? (this.endPublishTime = this.$dayjs(
              this.detailInfo.endPublishDate
            ).toDate())
          : "";
        this.detailInfo.lstSchoolCode = this.detailInfo.lstSchoolCode.map(code=>{
          return this.schoolCodeList.find(i=>{
            return code == i.schoolCode
          })
        })
        const schoolLevelMap = { 1: "Primary school", 2: "Secondery school" };
        if (this.detailInfo.level == 0) {
          this.schoolLevel = ["Primary school", "Secondery school"];
        } else if (!this.detailInfo.level) {
          this.schoolLevel = [];
        } else {
          this.schoolLevel = [schoolLevelMap[this.detailInfo.level]];
        }
      }
      setTimeout(function () {
        that.$store.state.edit = false;
      }, 500);
    },
    editorOnReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
    },
    checkEvent: function () {
      const schoolLevelMap = { "Primary school": 1, "Secondery school": 2 };
      if (this.detailInfo.lstSchoolEventImageDTO.length)
        this.detailInfo.imageListIsNull = "No";
      else this.detailInfo.imageListIsNull = "";
      if (!this.schoolLevel.length) this.detailInfo.level = "";
      else {
        if (this.schoolLevel.length == 2) this.detailInfo.level = 0;
        else this.detailInfo.level = schoolLevelMap[this.schoolLevel[0]];
      }
      this.detailInfo.isAllYearEvent = Number(this.detailInfo.isAllYearEvent);
      this.detailInfo.isEventFull
        ? (this.detailInfo.isEventFull = 1)
        : (this.detailInfo.isEventFull = 0);
      this.$refs["detailInfo"].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
    },
    handleRemove(file) {
      var index = "";
      this.detailInfo.lstSchoolEventImageDTO.forEach((item, i) => {
        if (item.eventImageUrl == file.eventImageUrl) {
          index = i;
        }
      });
      this.detailInfo.lstSchoolEventImageDTO.splice(index, 1);
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        that.$router.go(-1);
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [
            {
              name: this.$i18n.t("message.Confirm"),
              callBack: function () {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });
                that.callDelete();
              },
            },
            {
              name: this.$i18n.t("message.Cancel"),
              callBack: function () {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });
              },
            },
          ],
        });
      }
    },
    async getSchoolCodeList() {
      let obj = this.getAuthObj();
      obj.pageSize = 99999;
      obj.pageIndex = 1;
      obj.districtCode = this.detailInfo.eventDistrictCode;
      obj.apiUrl = this.apiConfig.schoolCodeList;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      const res = this.$lodash.orderBy(data.data.result.schools,'schoolName','asc')
      this.$set(this, "schoolCodeList", res);
    },
    async getDistrictGetlist() {
      let obj = this.getAuthObj();
      obj.apiUrl = this.apiConfig.districtGetlist;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$set(this, "districtGetlist", data.data.result);
    },
    async submit() {
      try {
        let obj = this.getAuthObj();
        for (var key in this.detailInfo) {
          if (key != "imageListIsNull") obj[key] = this.detailInfo[key];
        }
        var data;
        if (this.$route.query.id) {
          obj.userId = this.$store.state.userInfo.userId;
          obj.token = this.$store.state.userInfo.token;
          obj.id = this.$route.query.id;
          obj.lstSchoolCode = this.detailInfo.lstSchoolCode.map(i=>{
            return i.schoolCode
          })
          obj.apiUrl = this.apiConfig.schoolEventUpdate;
          data = await this.$store.dispatch("apiEvent", obj);
        } else {
          obj.userId = this.$store.state.userInfo.userId;
          obj.token = this.$store.state.userInfo.token;
          obj.lstSchoolCode = this.detailInfo.lstSchoolCode.map(i=>{
            return i.schoolCode
          })
          obj.apiUrl = this.apiConfig.schoolEventCreate;
          data = await this.$store.dispatch("apiEvent", obj);
        }
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        if (data.data.status_code === "0") {
          this.$store.state.edit = false;
          this.$router.go(-1);
        }
      } catch (err) {}
    },
    async uploadFile(params) {
      if (!this.handleCheckUploadFileSize(params.file)) return false;
      let obj = this.getAuthObj();
      obj.file = params.file;
      obj.apiUrl = this.apiConfig.upload;
      var data = await this.$store.dispatch("apiEventFromData", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;

      this.detailInfo.lstSchoolEventImageDTO.push({
        eventImageUrl: data.data.result.url,
        showEventImageUrl: data.data.result.showUrl,
        fileType: 1,
        sortOrder: 1,
      });
    },
    Delete() {
      this.showWarning(1);
    },
    async callDelete() {},
    checkIsAllYearRound() {
      const startDate = this.$dayjs().startOf("year");
      const endDate = this.$dayjs().endOf("year");
      return (
        !this.$dayjs(this.startSubDate).diff(startDate, "day") &&
        !this.$dayjs(this.endSubDate).diff(endDate, "day") &&
        !this.$dayjs(this.startSubTime).diff(startDate, "second") &&
        !this.$dayjs(this.endSubTime).diff(endDate, "second")
      );
    },
    handleChangeDate(e, type) {
      if (
        this[`${type}SubDate`] instanceof Date &&
        isNaN(this[`${type}SubDate`].getTime())
      )
        this[`${type}SubDate`] = "";

      if (
        this[`${type}SubTime`] instanceof Date &&
        isNaN(this[`${type}SubTime`].getTime())
      )
        this[`${type}SubTime`] = "";

      if (!(this[`${type}SubDate`] && this[`${type}SubTime`]))
        return (this.detailInfo[`${type}EventDate`] = "");

      const date = this.$dayjs(this[`${type}SubDate`]).format("YYYY-MM-DD");
      const time = this.$dayjs(this[`${type}SubTime`]).format("HH:mm:ss");
      this.detailInfo[`${type}EventDate`] = `${date} ${time}`;

      if (this.checkIsAllYearRound()) {
        this.allYearRoundIndicator = true;
      } else {
        this.allYearRoundIndicator = false;
      }
    },
    handleChangePublishDate(e, type) {
      const date = this.$dayjs(this[`${type}PublishDate`]).format("YYYY-MM-DD");
      const time = this.$dayjs(this[`${type}Publishtime`]).format("HH:mm:ss");
      this.detailInfo[`${type}PublishDate`] = `${date} ${time}`;
    },

    handleSelectEventAllYearRound(e) {
      if (e) {
        const startDate = this.$dayjs().startOf("year").toDate();
        const endDate = this.$dayjs().endOf("year").toDate();
        this.startSubDate = startDate;
        this.endSubDate = endDate;
        this.startSubTime = startDate;
        this.endSubTime = endDate;
        this.handleChangeDate(null, "start");
        this.handleChangeDate(null, "end");
      } else {
        this.startSubDate = "";
        this.endSubDate = "";
        this.startSubTime = "";
        this.endSubTime = "";
        this.startDate = "";
        this.endDate = "";
      }
    },
    handleDelectSchool(id) {
      this.detailInfo.lstSchoolCode = this.detailInfo.lstSchoolCode.filter(
        (i) => {
          return i !== id;
        }
      );
    },
    handleChangeScopeType(e) {
      if (e == 1) {
        this.level = 0;
        this.detailInfo.lstSchoolCode = [];
      } else if (e == 2) {
        this.detailInfo.lstDistritCode = [];
        this.detailInfo.lstSchoolCode = [];
      } else {
        this.level = 0;
        this.detailInfo.lstDistritCode = [];
      }
    },
    handleCopyTo() {
      this.$route.query.id = "";
      this.detailInfo = {
        eventTitle: this.detailInfo.eventTitle,
        ideasCategory: this.detailInfo.ideasCategory,
        startDate: this.detailInfo.startDate,
        endDate: this.detailInfo.endDate,
        eventDistrictCode: this.detailInfo.eventDistrictCode,
        lstDistritCode: this.detailInfo.lstDistritCode,
        level: this.detailInfo.lstDistritCode,
        lstSchoolCode: this.detailInfo.lstSchoolCode,
        status: 0,
        isEventFull: this.detailInfo.isEventFull,
        lstSchoolEventImageDTO: this.detailInfo.lstSchoolEventImageDTO,
        lstSchoolEventLangDTO: this.detailInfo.lstSchoolEventLangDTO,
        startEventDate: this.detailInfo.startEventDate,
        endEventDate: this.detailInfo.endEventDate,
        imageListIsNull: this.detailInfo.imageListIsNull,
        isAllYearEvent: this.detailInfo.isAllYearEvent,
        scopeType: this.detailInfo.scopeType,
      };
      this.$forceUpdate();
    },
    handleCheckUploadFileSize(file) {
      const sizeKB = file.size / 1024;
      if (sizeKB > 5120) {
        this.uploadErr = true;
        return false;
      } else {
        this.uploadErr = false;
        return true;
      }
    },
    handleSelectAllDistrit(){
      if(this.distritIsSelectAll){
        this.detailInfo.lstDistritCode = []
      }else{
        this.detailInfo.lstDistritCode = this.districtGetlist.map(i=>{
          return i.districtCode
        })
      }

    },
    handleCloseModel(e){
      this.isShowModel=false
    },
    handleSelectSchool(e){
      this.detailInfo.lstSchoolCode = e
      this.$forceUpdate()
    },
    handleShowModel(){
      this.isShowModel=true
    },
    handleChangeDistrictCode(e){
      this.detailInfo.lstSchoolCode=[]
    }
  },
  components: { vuedraggable ,schoolSelectModel},
};
</script>
<style lang="scss" scoped>
.schoolSelecter {
  ::v-deep .el-table::before {
    display: none;
  }
  ::v-deep .el-tag--small {
    display: none;
  }
}
</style>